module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"E-postadress":"Email address","Boka demo":"Book a demo","asd":"asd"},"sv":{"E-postadress":"E-postadress","Boka demo":"Boka demo","asd":"asd"}}')
  delete Component.options._Ctor
}
